$(document).ready(function(){
  
  $(".accordion-titel").click(function(){
    // $(this).toggleClass("active");
    $(this).parent(".accordion-item").find(".accordion-titel").toggleClass("active");
    $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-titel").removeClass("active");
    $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-titel").removeClass("active");
    
    $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
    $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
    $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
  });
  
});

// find-us-section

$(document).ready(function () {
    var $carousel = $(".find_us_inner_slide");
    var totalItems = $carousel.find(".slide_item").length;

    $carousel.owlCarousel({
        items: 1.5,
        loop: true,
        margin: 11,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        dots: false,
        nav: true,
        navText: [
          `<svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9" fill="none"><path d="M4.5 1L1 4.5L4.5 8" stroke="black"/></svg>`,
          `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none"><path d="M1 1L4.5 4.5L1 8" stroke="black"/></svg>`
        ],
        onTranslated: updateProgress,
      responsive: {
    
        1024: {
          items: 2.5
        },
    
        1366: {
          items: 2.5
        }
      }
      });

    function updateProgress(event) {
      var index = event.item.index - event.relatedTarget._clones.length / 2;
      var total = event.item.count;
      var current = (index % total + total) % total + 1;
      var percent = (current / total) * 100;
      $(".progress-bar").css("width", percent + "%");
    }

    // Initial call
    updateProgress({ item: $carousel.data('owl.carousel')._items[0], relatedTarget: $carousel.data('owl.carousel') });
  });




// 
$(document).ready(function () {
  var $carousel = $(".trustpilot_inner_slide");

  if ($carousel.length > 0) {
    var totalItems = $carousel.find(".tr_slide_item").length;

    $carousel.owlCarousel({
      items: 1.2,
      loop: true,
      margin: 11,
      autoplay: false,
      autoplayHoverPause: true,
      dots: false,
      nav: false,
      onTranslated: updateProgress,
      responsive: {
        1024: {
          items: 2.5
        },
        1366: {
          items: 3.5
        }
      }
    });

    function updateProgress(event) {
      var index = event.item.index - event.relatedTarget._clones.length / 2;
      var total = event.item.count;
      var current = (index % total + total) % total + 1;
      var percent = (current / total) * 100;
        $(".trustpilot-progress-bar").css("width", percent + "%");
    }

    // Initial call once Owl is initialized
    $carousel.on('initialized.owl.carousel', function (event) {
      updateProgress(event);
    });
  }
});




$(document).ready(function() {
  $('.h_customers_inner_slide').slick({
    centerMode: true,
    slidesToShow: 3,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    edgeFriction: 0.05,
    infinite: true, 
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
  });
});

(function () {
  const CART_TIMER_DURATION = 240;

  const onDocumentReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const BlackFridayBanner = (() => {
    let timerId = null;
    let banners = [];
    let resizeHandler = null;
    let orientationHandler = null;

    const clearTimer = () => {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    };

    const removeHandlers = () => {
      if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
        resizeHandler = null;
      }

      if (orientationHandler) {
        window.removeEventListener('orientationchange', orientationHandler);
        orientationHandler = null;
      }
    };

    const applyTypography = () => {
      banners.forEach((entry) => {
        entry.labelEl.style.fontWeight = entry.boldLabel ? '700' : '400';
        entry.countdownEl.style.fontWeight = entry.boldTime ? '700' : '400';
      });
    };

    const updateBannerHeight = () => {
      const bannerWrapper = document.querySelector('.mayas-bf-banner-wrapper');
      if (!bannerWrapper) {
        return;
      }

      const height = bannerWrapper.offsetHeight;
      document.documentElement.style.setProperty('--bf-banner-height', `${height}px`);
      document.body.classList.toggle('has-bf-banner', height > 0);
    };

    const formatCountdown = (diffMs) => {
      const totalSeconds = Math.floor(diffMs / 1000);
      const clampedSeconds = Math.max(totalSeconds, 0);
      const days = Math.floor(clampedSeconds / 86400);
      const hours = Math.floor((clampedSeconds % 86400) / 3600);
      const minutes = Math.floor((clampedSeconds % 3600) / 60);
      const seconds = clampedSeconds % 60;

      return `${days}d ${String(hours).padStart(2, '0')}t ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
    };

    const parseBanners = () => {
      const elements = Array.from(document.querySelectorAll('[data-bf-banner]'));

      banners = elements
        .map((banner) => {
          const endRaw = banner.dataset.bfEnd;
          const countdownEl = banner.querySelector('[data-bf-countdown]');
          const labelEl = banner.querySelector('[data-bf-label]');
          const expiredMessage =
            banner.dataset.bfExpiredMessage || 'BLACK FRIDAY ER SLUT 🖤';

          if (!endRaw || !countdownEl || !labelEl) {
            return null;
          }

          const endDate = new Date(endRaw);

          if (Number.isNaN(endDate.getTime())) {
            banner.style.display = 'none';
            return null;
          }

          banner.classList.remove('is-finished');

          const container = banner.closest('.mayas-bf-banner-wrapper');

          return {
            banner,
            countdownEl,
            labelEl,
            endDate,
            expiredMessage,
            boldLabel: container?.dataset.bfBoldLabel === 'true',
            boldTime: container?.dataset.bfBoldTime === 'true',
          };
        })
        .filter(Boolean);
    };

    const updateCountdowns = () => {
      if (!banners.length) {
        return;
      }

      const now = Date.now();
      let activeBanners = 0;

      banners.forEach((entry) => {
        const diff = entry.endDate.getTime() - now;

        if (diff <= 0) {
          entry.countdownEl.textContent = '';
          entry.labelEl.textContent = entry.expiredMessage;
          entry.banner.classList.add('is-finished');
        } else {
          entry.countdownEl.textContent = formatCountdown(diff);
          entry.banner.classList.remove('is-finished');
          activeBanners += 1;
        }
      });

      if (activeBanners === 0) {
        clearTimer();
      }
    };

    const init = () => {
      clearTimer();
      removeHandlers();
      parseBanners();

      if (!banners.length) {
        return;
      }

      applyTypography();
      updateBannerHeight();
      resizeHandler = () => window.requestAnimationFrame(updateBannerHeight);
      orientationHandler = () => window.requestAnimationFrame(updateBannerHeight);
      window.addEventListener('resize', resizeHandler);
      window.addEventListener('orientationchange', orientationHandler);

      updateCountdowns();
      timerId = window.setInterval(updateCountdowns, 1000);
    };

    return { init };
  })();

  const PdpCountdown = (() => {
    const timers = new WeakMap();

    const formatTime = (totalSeconds) => {
      const clamped = Math.max(totalSeconds, 0);
      const days = Math.floor(clamped / 86400);
      const hours = Math.floor((clamped % 86400) / 3600);
      const minutes = Math.floor((clamped % 3600) / 60);
      const seconds = clamped % 60;

      return `${days}d ${String(hours).padStart(2, '0')}t ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
    };

    const createTimer = (element) => {
      const timeEl = element.querySelector('[data-pdp-countdown-time]');

      if (!timeEl) {
        return null;
      }

      const endAttr = element.dataset.pdpCountdownEnd;
      const endDate = endAttr ? new Date(endAttr) : null;
      const boldLabel = element.dataset.pdpCountdownBoldLabel === 'true';
      const boldTime = element.dataset.pdpCountdownBoldTime === 'true';

      const labelEl = element.querySelector('.mayas-pdp-countdown__label');
      if (labelEl) {
        labelEl.style.fontWeight = boldLabel ? '700' : '400';
      }
      timeEl.style.fontWeight = boldTime ? '700' : '400';

      if (!endDate || Number.isNaN(endDate.getTime())) {
        timeEl.textContent = '00:00:00';
        element.classList.add('is-finished');
        return null;
      }

      let intervalId = null;

      const update = () => {
        const diff = Math.floor((endDate.getTime() - Date.now()) / 1000);

        if (diff <= 0) {
          timeEl.textContent = '00:00:00';
          element.classList.add('is-finished');
          stop();
          return;
        }

        timeEl.textContent = formatTime(diff);
        element.classList.remove('is-finished');
      };

      const stop = () => {
        if (intervalId !== null) {
          window.clearInterval(intervalId);
          intervalId = null;
        }
      };

      const start = () => {
        stop();
        update();
        intervalId = window.setInterval(update, 1000);
      };

      const api = {
        start,
        stop,
        teardown() {
          stop();
          timers.delete(element);
        }
      };

      timers.set(element, api);
      api.start();

      return api;
    };

    const init = (scope = document) => {
      const elements = Array.from(scope.querySelectorAll('[data-pdp-countdown]'));

      elements.forEach((element) => {
        if (timers.has(element)) {
          timers.get(element).start();
        } else {
          createTimer(element);
        }
      });
    };

    return { init };
  })();

  const CartReservationTimers = (() => {
    const timers = new WeakMap();
    let drawerObserver = null;
    let drawerFinder = null;

    const formatTime = (valueInSeconds) => {
      const minutes = Math.floor(valueInSeconds / 60);
      const seconds = valueInSeconds % 60;

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const createTimer = (element) => {
      const timeEl = element.querySelector('[data-cart-reservation-time]');
      const messageEl = element.querySelector('[data-cart-reservation-message]');

      if (!timeEl || !messageEl) {
        return null;
      }

      const activeText =
        element.dataset.cartReservationActiveText || messageEl.textContent.trim();
      const expiredText =
        element.dataset.cartReservationExpiredText || 'Din kurv er ikke længere reserveret';

      let remaining = CART_TIMER_DURATION;
      let intervalId = null;

      const render = () => {
        if (remaining <= 0) {
          messageEl.textContent = expiredText;
          timeEl.textContent = '';
          element.classList.add('is-expired');
          element.dataset.cartTimerActive = 'false';
          return true;
        }

        messageEl.textContent = activeText;
        timeEl.textContent = formatTime(remaining);
        element.classList.remove('is-expired');
        element.dataset.cartTimerActive = 'true';

        return false;
      };

      const stop = () => {
        if (intervalId !== null) {
          window.clearInterval(intervalId);
          intervalId = null;
        }

        element.dataset.cartTimerActive = 'false';
      };

      const start = () => {
        stop();
        remaining = CART_TIMER_DURATION;
        render();

        if (remaining <= 0) {
          return;
        }

        intervalId = window.setInterval(() => {
          remaining -= 1;

          if (render()) {
            stop();
          }
        }, 1000);
      };

      const api = {
        start,
        stop,
        teardown() {
          stop();
          timers.delete(element);
        },
      };

      timers.set(element, api);
      api.start();

      return api;
    };

    const getOrCreateTimer = (element) => {
      if (timers.has(element)) {
        const timer = timers.get(element);
        timer.start();
        return timer;
      }

      return createTimer(element);
    };

    const init = (root = document) => {
      const elements = Array.from(root.querySelectorAll('[data-cart-reservation]'));

      elements.forEach((element) => {
        getOrCreateTimer(element);
      });
    };

    const handleDrawerState = (drawer) => {
      const isOpen =
        drawer.classList.contains('is-open') || drawer.hasAttribute('open');
      const timersInDrawer = Array.from(
        drawer.querySelectorAll('[data-cart-reservation]'),
      );

      timersInDrawer.forEach((element) => {
        const timer = getOrCreateTimer(element);

        if (!timer) {
          return;
        }

        if (isOpen) {
          timer.start();
        } else {
          timer.stop();
        }
      });
    };

    const attachDrawerObserver = (drawer) => {
      if (!drawer) {
        return;
      }

      if (drawerObserver) {
        drawerObserver.disconnect();
      }

      drawerObserver = new MutationObserver(() => handleDrawerState(drawer));
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });

      handleDrawerState(drawer);
    };

    const observeDrawer = () => {
      const drawer = document.getElementById('cart-drawer');

      if (drawer) {
        attachDrawerObserver(drawer);
        return;
      }

      if (drawerFinder) {
        return;
      }

      drawerFinder = new MutationObserver(() => {
        const newDrawer = document.getElementById('cart-drawer');

        if (newDrawer) {
          attachDrawerObserver(newDrawer);
          drawerFinder.disconnect();
          drawerFinder = null;
        }
      });

      drawerFinder.observe(document.body, { childList: true, subtree: true });
    };

    return { init, observeDrawer };
  })();

  const VariantDiscounts = (() => {
    const controllers = new WeakMap();

    const createController = (element) => {
      const badgeEl = element.querySelector('[data-variant-discount-badge]');

      if (!badgeEl) {
        return null;
      }

      const productFallback = element.dataset.variantDiscountProduct || '';

      let variantMap = {};
      const mapAttr = element.getAttribute('data-variant-discount-map');

      if (mapAttr) {
        try {
          variantMap = JSON.parse(mapAttr);
        } catch (error) {
          variantMap = {};
        }
      }

      const update = (variantId) => {
        const key = variantId ? String(variantId) : null;
        const text = (key && variantMap[key]) || productFallback;

        if (text) {
          badgeEl.textContent = text;
          badgeEl.hidden = false;
          element.classList.remove('is-hidden');
        } else {
          badgeEl.hidden = true;
          element.classList.add('is-hidden');
        }
      };

      const controller = { update };
      controllers.set(element, controller);

      return controller;
    };

    const init = (root = document) => {
      const elements = Array.from(root.querySelectorAll('[data-variant-discount-root]'));

      elements.forEach((element) => {
        const controller = createController(element);

        if (controller) {
          const selected = element.dataset.selectedVariant || null;
          controller.update(selected);
        }
      });
    };

    const update = (variantId, formId) => {
      const selector = formId
        ? `[data-variant-discount-root][data-product-form="${formId}"]`
        : '[data-variant-discount-root]';

      const elements = document.querySelectorAll(selector);

      elements.forEach((element) => {
        const controller = controllers.get(element) || createController(element);

        if (!controller) {
          return;
        }

        if (variantId) {
          element.dataset.selectedVariant = String(variantId);
        } else {
          element.removeAttribute('data-selected-variant');
        }

        controller.update(variantId ? String(variantId) : null);
      });
    };

    return { init, update };
  })();

  const initializeAll = (scope = document) => {
    BlackFridayBanner.init();
    CartReservationTimers.init(scope);
    CartReservationTimers.observeDrawer();
    VariantDiscounts.init(scope);
    PdpCountdown.init(scope);
  };

  onDocumentReady(() => initializeAll(document));

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    initializeAll(event.target);
  });

  document.documentElement.addEventListener('cart:refresh', () => {
    CartReservationTimers.init(document);
    CartReservationTimers.observeDrawer();
  });

  document.addEventListener('variant:change', (event) => {
    const formId = event.detail?.formId;
    const variantId = event.detail?.variant?.id;

    VariantDiscounts.update(variantId, formId);
  });

  document.addEventListener('product:rerender', () => {
    window.requestAnimationFrame(() => {
      VariantDiscounts.init(document);
      PdpCountdown.init(document);
    });
  });

  window.MAYASCartReservationTimers = CartReservationTimers;
  window.MAYASBlackFridayBanner = BlackFridayBanner;
  window.MAYASVariantDiscounts = VariantDiscounts;
  window.MAYASPdpCountdown = PdpCountdown;
})();

$('.logo_flex').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    // adaptiveHeight: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
});



$(document).ready(function() {
  $('.image_inner_slide').slick({
    centerMode: true,
    slidesToShow: 3,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    edgeFriction: 0.05,
    infinite: true, 
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
  });
  // $('.image_inner_slide').slick('slickGoTo', 2);
});


$(document).ready(function () {
  if ($(window).width() <= 767) {
    $(".footer-title-div").click(function () {
      console.log("click");
      $(this).parent().siblings().find(".footer-menu-div").slideUp();
      $(this).parent().siblings().removeClass("active");
      $(this).parent().toggleClass("active");
      $(this).next().slideToggle();
    });
  }
});

$(document).ready(function () {
  var $carousel = $(".gallery-block-wrapper");
  var totalItems = $carousel.find(".slide_item").length;

  $carousel.owlCarousel({
    items: 1.5,
    loop: true,
    margin: 11,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    navText: [
      `<svg xmlns="http://www.w3.org/2000/svg" width="5" height="9" viewBox="0 0 5 9" fill="none"><path d="M4.5 1L1 4.5L4.5 8" stroke="black"/></svg>`,
      `<svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none"><path d="M1 1L4.5 4.5L1 8" stroke="black"/></svg>`
    ],
    onTranslated: updateProgress,
    responsive: {
      1024: {
        items: 2.5
      },
      1366: {
        items: 2.5
      }
    }
  });

  function updateProgress(event) {
    var index = event.item.index - event.relatedTarget._clones.length / 2;
    var total = event.item.count;
    var current = (index % total + total) % total + 1;
    var percent = (current / total) * 100;
    $(".progress-bar").css("width", percent + "%");
  }
});




document.addEventListener('DOMContentLoaded', function () {
  const scrollArea = document.querySelector('scroll-carousel#featured-collections-product-list-carousel-collection-1');
  if (scrollArea) {
    scrollArea.style.overflowX = 'auto';
    scrollArea.style.scrollbarWidth = 'thin';
  }
});








function updateCountdown() {
  const messageEl = document.getElementById("countdown-message");
  const now = new Date();
  // Convert to Danish time (Europe/Copenhagen handles daylight saving too)
  const danishNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Copenhagen" }));
  // Set target today at 15:00 Danish time
  const cutoff = new Date(danishNow);
  cutoff.setHours(15, 0, 0, 0); // 15:00:00
  // Compare current Danish time with 15:00
  if(messageEl){
  if (danishNow < cutoff) {
    const diff = cutoff - danishNow;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    messageEl.innerHTML = `Bestil inden <strong>${hours} timer ${minutes} min ${seconds} sek</strong> og vi afsender din pakke <strong>i dag</strong>.`;
  } else {
    messageEl.innerHTML = `Bestil nu og vi afsender din pakke <strong>i morgen</strong>.`;
  }
  }
}
// Update every second
setInterval(updateCountdown, 1000);
updateCountdown(); // Initial call


$(document).on('click', 'input[type="radio"]', function () {
    let inputOpation = $(this).data('opation');
    let inputLabel = $(this).data('label');
    let inventory = parseInt($(this).data('inventory'), 10);

    

    // Remove previous orange classes
    $('.inventory-icon').removeClass('orange');
    $('#stock-status').removeClass('orange');
    $('.in-stock-out').removeClass('orange');

    // Update selected value
    $('span.pro_selected_value').each(function () {
        if ($(this).data('opation') === inputOpation) {
            $(this).text(inputLabel); 
        }
    });

    // Apply 'orange' only if inventory is > 0 and < 5
    if (inventory <= 0) {
        $('.inventory-icon').addClass('orange');
        $('#stock-status').addClass('orange');
        $('.in-stock-out').addClass('orange');
    }
});


$(document).on('click', '.block-swatch', function() {
  $('.in-stock-out').show();
  $('.main-in-stock-out').hide();

  if ($(this).hasClass('is-disabled')) {
    $('.in_stock').hide();
    $('.payment_stock_avalablity').addClass('pay_out_stock');
    $('.out_of_stock').show();
    $('.in_stock_msg').hide();
    $('.pre_order').hide();
  }
  else if ($(this).hasClass('is-preorder')) {
    $('.in_stock').hide();
    $('.payment_stock_avalablity').removeClass('pay_out_stock');
    $('.out_of_stock').hide();
    $('.in_stock_msg').hide();
    $('.pre_order').show();
  }else {
    $('.in_stock').show();
    $('.payment_stock_avalablity').removeClass('pay_out_stock');
    $('.in_stock_msg').show();
    $('.out_of_stock').hide();
    $('.pre_order').hide();
  }
});







$(document).ready(function () {
  // On page load, set the default selected color
  const selectedColor = $('.thumbnail-swatch.is-selected .getcolor_thumbnail').text().trim();
  $('.product-option-value').text(selectedColor);

  // On hover, change color name and add active class
  $('.thumbnail-swatch').on('mouseenter', function () {
    const colorName = $(this).find('.getcolor_thumbnail').text().trim();
    $('.product-option-value').text(colorName);

    // Add active class to hovered item
    $(this).addClass('active');
  });

  // On hover out, reset to selected color and remove active class
  $('.thumbnail-swatch').on('mouseleave', function () {
    const selectedColor = $('.thumbnail-swatch.is-selected .getcolor_thumbnail').text().trim();
    $('.product-option-value').text(selectedColor);

    // Remove active class from all swatches
    $('.thumbnail-swatch').removeClass('active');
  });
  
});

document.addEventListener('click', function (e) {
  if (e.target.getAttribute('part') === 'overlay') {
    console.log('Overlay clicked');

    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer) {
      cartDrawer.removeAttribute('open');
      cartDrawer.classList.remove('is-open', 'cart_drawer_open');
    }

    document.body.classList.remove('overflow-hidden');

    const cartDrawerContainer = document.querySelector('.cart-drawer');
    if (cartDrawerContainer) {
      cartDrawerContainer.style.display = 'none';
    }
  }
});



$('.ad_to_cart_coll').click(function (event) {
  event.preventDefault(); // Stop auto drawer open from aria-controls

  const ID = $(this).attr("data-var_id");

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: ID,
      quantity: 1
    },
    dataType: 'json',
    success: function () {
      // Step 1: Refresh cart content
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      // Wait 200ms for data to load, then open the drawer
      setTimeout(function () {
        // This simulates clicking the cart icon or opening drawer manually
        document.querySelector('[aria-controls="cart-drawer"]').click();
      }, 2000);

    
    }
  });
});
